{
  "schema": "draft-jurkovikj-json-three-way-merge-00-vectors-v1",
  "draft": "draft-jurkovikj-json-three-way-merge-00",
  "comparison": "normalized_json_value",
  "input_representation": {
    "encoding": "json_string_containing_utf8_text",
    "decoded_value": "exact input text supplied to the merge processor",
    "limitation": "invalid UTF-8 octet sequences require a separate byte-oriented suite"
  },
  "successful_merges": [
    {
      "id": "no-change",
      "base": "{\"x\":1}",
      "source": "{\"x\":1.0}",
      "target": "{\"x\":1e0}",
      "expected": {"status": "merged", "merged": {"x": 1}}
    },
    {
      "id": "source-only",
      "base": "{\"x\":1}",
      "source": "{\"x\":2}",
      "target": "{\"x\":1}",
      "expected": {"status": "merged", "merged": {"x": 2}}
    },
    {
      "id": "target-only",
      "base": "{\"x\":1}",
      "source": "{\"x\":1}",
      "target": "{\"x\":2}",
      "expected": {"status": "merged", "merged": {"x": 2}}
    },
    {
      "id": "agreement",
      "base": "{\"x\":1}",
      "source": "{\"x\":2}",
      "target": "{\"x\":2.0}",
      "expected": {"status": "merged", "merged": {"x": 2}}
    },
    {
      "id": "independent-members",
      "base": "{\"a\":0,\"b\":0}",
      "source": "{\"a\":1,\"b\":0}",
      "target": "{\"a\":0,\"b\":2}",
      "expected": {"status": "merged", "merged": {"a": 1, "b": 2}}
    },
    {
      "id": "source-delete",
      "base": "{\"x\":1}",
      "source": "{}",
      "target": "{\"x\":1}",
      "expected": {"status": "merged", "merged": {}}
    },
    {
      "id": "target-delete",
      "base": "{\"x\":1}",
      "source": "{\"x\":1}",
      "target": "{}",
      "expected": {"status": "merged", "merged": {}}
    },
    {
      "id": "both-delete",
      "base": "{\"x\":1}",
      "source": "{}",
      "target": "{}",
      "expected": {"status": "merged", "merged": {}}
    },
    {
      "id": "one-sided-add-null",
      "base": "{}",
      "source": "{\"x\":null}",
      "target": "{}",
      "expected": {"status": "merged", "merged": {"x": null}}
    },
    {
      "id": "target-only-add",
      "base": "{}",
      "source": "{}",
      "target": "{\"x\":1}",
      "expected": {"status": "merged", "merged": {"x": 1}}
    },
    {
      "id": "agreed-add",
      "base": "{}",
      "source": "{\"x\":1}",
      "target": "{\"x\":1.0}",
      "expected": {"status": "merged", "merged": {"x": 1}}
    },
    {
      "id": "agreed-type-change",
      "base": "1",
      "source": "{\"x\":2}",
      "target": "{\"x\":2}",
      "expected": {"status": "merged", "merged": {"x": 2}}
    },
    {
      "id": "one-sided-type-change",
      "base": "1",
      "source": "1.0",
      "target": "{\"x\":2}",
      "expected": {"status": "merged", "merged": {"x": 2}}
    },
    {
      "id": "large-integer-normalization",
      "base": "9007199254740992",
      "source": "9007199254740993",
      "target": "3",
      "expected": {"status": "merged", "merged": 3}
    },
    {
      "id": "negative-zero-normalization",
      "base": "{\"x\":-0}",
      "source": "{\"x\":0.0}",
      "target": "{\"x\":-0.0}",
      "expected": {"status": "merged", "merged": {"x": 0}},
      "assertion": "serialized merged value does not contain negative zero"
    },
    {
      "id": "subnormal-equality",
      "base": "5e-324",
      "source": "4.9e-324",
      "target": "1",
      "expected": {"status": "merged", "merged": 1}
    }
  ],
  "conflicts": [
    {
      "id": "scalar-divergence",
      "base": "1",
      "source": "2",
      "target": "3",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_value_change",
            "path": "",
            "base": {"state": "present", "value": 1},
            "source": {"state": "present", "value": 2},
            "target": {"state": "present", "value": 3}
          }
        ]
      }
    },
    {
      "id": "type-divergence",
      "base": "1",
      "source": "\"source\"",
      "target": "{\"x\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_type_change",
            "path": "",
            "base": {"state": "present", "value": 1},
            "source": {"state": "present", "value": "source"},
            "target": {"state": "present", "value": {"x": 2}}
          }
        ]
      }
    },
    {
      "id": "add-add",
      "base": "{}",
      "source": "{\"x\":1}",
      "target": "{\"x\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "add_add",
            "path": "/x",
            "base": {"state": "missing"},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          }
        ]
      }
    },
    {
      "id": "delete-edit",
      "base": "{\"x\":1}",
      "source": "{}",
      "target": "{\"x\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "source_delete_target_edit",
            "path": "/x",
            "base": {"state": "present", "value": 1},
            "source": {"state": "missing"},
            "target": {"state": "present", "value": 2}
          }
        ]
      }
    },
    {
      "id": "edit-delete",
      "base": "{\"x\":1}",
      "source": "{\"x\":2}",
      "target": "{}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "source_edit_target_delete",
            "path": "/x",
            "base": {"state": "present", "value": 1},
            "source": {"state": "present", "value": 2},
            "target": {"state": "missing"}
          }
        ]
      }
    },
    {
      "id": "divergent-added-objects",
      "base": "{}",
      "source": "{\"x\":{\"a\":1}}",
      "target": "{\"x\":{\"b\":2}}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "add_add",
            "path": "/x",
            "base": {"state": "missing"},
            "source": {"state": "present", "value": {"a": 1}},
            "target": {"state": "present", "value": {"b": 2}}
          }
        ]
      }
    },
    {
      "id": "null-versus-delete",
      "base": "{\"x\":1}",
      "source": "{\"x\":null}",
      "target": "{}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "source_edit_target_delete",
            "path": "/x",
            "base": {"state": "present", "value": 1},
            "source": {"state": "present", "value": null},
            "target": {"state": "missing"}
          }
        ]
      }
    },
    {
      "id": "add-add-null",
      "base": "{}",
      "source": "{\"x\":null}",
      "target": "{\"x\":1}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "add_add",
            "path": "/x",
            "base": {"state": "missing"},
            "source": {"state": "present", "value": null},
            "target": {"state": "present", "value": 1}
          }
        ]
      }
    },
    {
      "id": "nested-type-conflict",
      "base": "{\"a\":{\"b\":1}}",
      "source": "{\"a\":{\"b\":\"source\"}}",
      "target": "{\"a\":{\"b\":true}}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_type_change",
            "path": "/a/b",
            "base": {"state": "present", "value": 1},
            "source": {"state": "present", "value": "source"},
            "target": {"state": "present", "value": true}
          }
        ]
      }
    },
    {
      "id": "decoded-token-sequence-order",
      "base": "{\"a\":{\"b\":0},\"a!b\":0}",
      "source": "{\"a\":{\"b\":1},\"a!b\":1}",
      "target": "{\"a\":{\"b\":2},\"a!b\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_value_change",
            "path": "/a/b",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          },
          {
            "kind": "concurrent_value_change",
            "path": "/a!b",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          }
        ]
      }
    },
    {
      "id": "empty-member-name-order",
      "base": "{\"\":0,\"a\":0}",
      "source": "{\"\":1,\"a\":1}",
      "target": "{\"\":2,\"a\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_value_change",
            "path": "/",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          },
          {
            "kind": "concurrent_value_change",
            "path": "/a",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          }
        ]
      }
    },
    {
      "id": "escaped-path-order",
      "base": "{\"z\":0,\"a/b\":0,\"m~n\":0}",
      "source": "{\"z\":1,\"a/b\":1,\"m~n\":1}",
      "target": "{\"z\":2,\"a/b\":2,\"m~n\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_value_change",
            "path": "/a~1b",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          },
          {
            "kind": "concurrent_value_change",
            "path": "/m~0n",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          },
          {
            "kind": "concurrent_value_change",
            "path": "/z",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          }
        ]
      }
    },
    {
      "id": "utf16-path-order",
      "base": "{\"\\ue000\":0,\"\\ud83d\\ude00\":0}",
      "source": "{\"\\ue000\":1,\"\\ud83d\\ude00\":1}",
      "target": "{\"\\ue000\":2,\"\\ud83d\\ude00\":2}",
      "expected": {
        "status": "conflict",
        "conflicts": [
          {
            "kind": "concurrent_value_change",
            "path": "/\ud83d\ude00",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          },
          {
            "kind": "concurrent_value_change",
            "path": "/\ue000",
            "base": {"state": "present", "value": 0},
            "source": {"state": "present", "value": 1},
            "target": {"state": "present", "value": 2}
          }
        ]
      }
    }
  ],
  "unsupported_arrays": [
    {
      "id": "root-array",
      "base": "[]",
      "source": "{}",
      "target": "{}",
      "expected": {
        "status": "unsupported",
        "error": {"code": "arrays_not_supported", "side": "base", "path": ""}
      }
    },
    {
      "id": "nested-array",
      "base": "{\"items\":null}",
      "source": "{\"items\":[1]}",
      "target": "{\"items\":null}",
      "expected": {
        "status": "unsupported",
        "error": {"code": "arrays_not_supported", "side": "source", "path": "/items"}
      }
    },
    {
      "id": "equal-arrays",
      "base": "{\"items\":[1]}",
      "source": "{\"items\":[1]}",
      "target": "{\"items\":[1]}",
      "expected": {
        "status": "unsupported",
        "error": {"code": "arrays_not_supported", "side": "base", "path": "/items"}
      }
    },
    {
      "id": "least-array-path",
      "base": "{\"z\":[],\"a\":{\"items\":[]}}",
      "source": "{}",
      "target": "{}",
      "expected": {
        "status": "unsupported",
        "error": {"code": "arrays_not_supported", "side": "base", "path": "/a/items"}
      }
    }
  ],
  "invalid_input_precedence": [
    {
      "id": "invalid-base-first",
      "base": "{broken",
      "source": "[]",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "invalid_json", "side": "base", "path": ""}}
    },
    {
      "id": "source-array-before-target",
      "base": "{}",
      "source": "[]",
      "target": "{broken",
      "expected": {"status": "unsupported", "error": {"code": "arrays_not_supported", "side": "source", "path": ""}}
    },
    {
      "id": "decoded-duplicate",
      "base": "{\"a\":1,\"\\u0061\":2}",
      "source": "{}",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "duplicate_object_name", "side": "base", "path": ""}}
    },
    {
      "id": "number-overflow",
      "base": "{}",
      "source": "1e309",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "number_out_of_binary64_range", "side": "source", "path": ""}}
    },
    {
      "id": "nested-decoded-duplicate-path",
      "base": "{\"outer\":{\"a\":1,\"\\u0061\":2}}",
      "source": "{}",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "duplicate_object_name", "side": "base", "path": "/outer"}}
    },
    {
      "id": "nested-number-overflow-path",
      "base": "{}",
      "source": "{\"outer\":{\"n\":1e309}}",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "number_out_of_binary64_range", "side": "source", "path": "/outer/n"}}
    },
    {
      "id": "leading-bom",
      "base": "\ufeff{}",
      "source": "{}",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "invalid_json", "side": "base", "path": ""}}
    },
    {
      "id": "lone-surrogate-escape",
      "base": "\"\\uD800\"",
      "source": "{}",
      "target": "{}",
      "expected": {"status": "invalid_input", "error": {"code": "invalid_json", "side": "base", "path": ""}}
    }
  ]
}
